import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Dropdown} from "primereact/dropdown";
import {Column} from "primereact/column";
import {DataTable} from 'primereact/datatable';
import axios from "axios";
import {BlockUI} from "primereact/blockui";
import {Button} from "primereact/button";

const PurchaseorderInventorydocumentCopyDndComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, action, id} = useParams();
  const [formData, setFormData] = useState({});
  const [requests, setRequests] = useState([]);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingDropTransfer, setLoadingDropTransfer] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);
  const receiptId = window.App.urlVars()?.receiptId;
  const [loadingRequests, setLoadingRequests] = useState(false);
  const [loadingItems, setLoadingItems] = useState(false);
  const [draggingItemIds, setDraggingItemIds] = useState([]);
  const [draggingItemLabel, setDraggingItemLabel] = useState('');
  const [dragOverTargetId, setDragOverTargetId] = useState(null);

  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  const linkedInventoryDocumentItemIds = requests.reduce((acc, requestItem) => {
    const inventoryDocumentItems = requestItem?.inventory_document_items || [];
    inventoryDocumentItems.forEach((inventoryDocumentItem) => {
      if (inventoryDocumentItem?.id) {
        acc[inventoryDocumentItem.id] = true;
      }
    });
    return acc;
  }, {});

  const [selectedRequests, setSelectedRequests] = useState([]);

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    if (!receiptId) return;
    setLoadingRequests(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    apiCall('GET', `/api/v2/receipt-item?search[receipt][operator]==&search[receipt][value]=${receiptId}`)
      .then(response => {
        const requestItems = response.data.data.items || [];
        setTotalRecords(response.data.data.total_item_count);
        setRequests(requestItems);
        const expanded = {};
        requestItems.forEach((item) => {
          expanded[item.id] = true;
        });
        setExpandedRows(expanded);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString());
      })
      .finally(() => setLoadingRequests(false));
  };
  
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const [totalRecordsItems, setTotalRecordsItems] = useState(0);
  const [rowsItems, setRowsItems] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dtItems = useRef(null);
  const [lazyParamsItems, setLazyParamsItems] = useState({
    first: 0,
    rows: rowsItems,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
    filters: {
      purchase_order: {value: id, matchMode: 'equals'}
    }
  });

  const loadLazyDataItems = () => {
    setLoadingItems(true);
    apiCall('GET', `/api/v2/inventory-document-item?search[inventory_document][operator]==&search[inventory_document][value]=${window.App.urlVars()?.inventoryDocumentId}`)
      .then(response => {
        setTotalRecordsItems(response.data.data.total_item_count);
        setItems(response.data.data.items);
      })
      .finally(() => setLoadingItems(false));
  };
    
  const onPageItems = (event) => {
    let _lazyParams = {...lazyParamsItems, ...event};
    setLazyParamsItems(_lazyParams);
  }
  const onSortItems = (event) => {
    let _lazyParams = {...lazyParamsItems, ...event};
    setLazyParamsItems(_lazyParams);
  }
  const onFilterItems = (event) => {
    let _lazyParams = {...lazyParamsItems, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParamsItems(_lazyParams);
  }
  const pagerItems = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRowsItems(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const isRequestItemCompleted = (requestItem) => {
    const requestQuantity = Number(requestItem?.quantity || 0);
    const linkedQuantitySum = (requestItem?.inventory_document_items || []).reduce((sum, item) => {
      return sum + Number(item?.quantity || 0);
    }, 0);
    return Math.abs(requestQuantity - linkedQuantitySum) < 0.000001;
  };

  const handleDeleteInventoryDocumentItem = async (inventoryDocumentItemId) => {
    if (!inventoryDocumentItemId) return;
    setLoading(true);
    setLoadingDropTransfer(true);
    setLoadingRequests(true);
    setLoadingItems(true);
    try {
      await apiCall('patch', `/api/v2/inventory-document-item/transfer-supplier/${inventoryDocumentItemId}`, {
          receipt_item: null
        }
      );
      window.App.toastShow('success', 'Sikeres törlés!');
      await loadLazyData();
      await loadLazyDataItems();
    } catch (error) {
      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
    } finally {
      setLoading(false);
      setLoadingDropTransfer(false);
      setLoadingRequests(false);
      setLoadingItems(false);
    }
  };

  const rowExpansionTemplate = (rowData) => {
    const inventoryDocumentItems = rowData?.inventory_document_items || [];
    return (
      <div className="p-p-2" style={{ background: '#fafafa' }}>
        {!inventoryDocumentItems.length ? (
          <div
            style={{
              fontSize: '0.85rem',
              fontWeight: 600,
              color: '#6c757d'
            }}
          >
            {t('noLinkedDeliveryNoteItem')}
          </div>
        ) : (
          <>
            <div
              style={{
                fontSize: '0.85rem',
                fontWeight: 600,
                color: '#6c757d',
                marginBottom: '8px'
              }}
            >
              {t('linkedDeliveryNoteItems')}
            </div>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' }}>
              <thead>
                <tr>
                  <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #dee2e6' }}>
                    {t('columnItem')}
                  </th>
                  <th style={{ textAlign: 'right', padding: '8px', borderBottom: '1px solid #dee2e6' }}>
                    {t('columnQuantity')}
                  </th>
                  <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #dee2e6' }}>
                    {t('columnDeliveryNoteNumber')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {inventoryDocumentItems.map((item) => (
                  <tr key={item.id}>
                    <td style={{ padding: '8px', borderBottom: '1px solid #f1f3f5' }}>
                      {item?.material?.name || '-'}
                    </td>
                    <td style={{ padding: '8px', textAlign: 'right', borderBottom: '1px solid #f1f3f5' }}>
                      {Number(item?.quantity || 0)} {item?.unit?.name || ''}
                    </td>
                    <td style={{ padding: '8px', borderBottom: '1px solid #f1f3f5' }}>
                      {item?.inventory_document?.document_number || '-'}
                    </td>
                    <td style={{ padding: '8px', textAlign: 'right', borderBottom: '1px solid #f1f3f5' }}>
                      <Button
                        type="button"
                        icon="pi pi-trash"
                        className="p-button-danger p-button-sm"
                        tooltip={t('delete')}
                        tooltipOptions={{ position: 'top' }}
                        disabled={loadingDropTransfer || loadingRequests || loadingItems}
                        onClick={() => handleDeleteInventoryDocumentItem(item.id)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
      </div>
    );
  };

  const handleDragStart = (event, item) => {
    if (formData.status === 'ORDERED' || formData.status === 'DELETED' || formData.status === 'CLOSED') {
      return;
    }
    let draggedItems = [item];
    if (Array.isArray(selectedRequests) && selectedRequests.length > 0) {
      const isPartOfSelection = selectedRequests.some(sel => sel.id === item.id);
      if (isPartOfSelection) {
        draggedItems = selectedRequests;
      }
    }
    const draggedIds = draggedItems.map(i => i.id);
    const payload = {
      source: 'purchase-order-request-items',
      ids: draggedIds,
    };
    setDraggingItemIds(draggedIds);
    setDraggingItemLabel(
      draggedItems.length === 1
        ? (draggedItems[0]?.description || '')
        : `${draggedItems.length} tétel`
    );
    event.dataTransfer.setData("application/json", JSON.stringify(payload));
    event.dataTransfer.effectAllowed = 'move';
  };

  const handleDragEnd = () => {
    setDraggingItemIds([]);
    setDraggingItemLabel('');
    setDragOverTargetId(null);
  };

  const renderDropCell = (content, rowData, align = 'left', showBadge = false) => (
    <div
      onDragOver={(e) => {
        e.preventDefault();
        setDragOverTargetId(rowData.id);
      }}
      onDragLeave={() => {
        setDragOverTargetId((prev) => (prev === rowData.id ? null : prev));
      }}
      onDrop={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragOverTargetId(null);
        handleDrop(e, "right", rowData.id);
      }}
      style={{
        minHeight: '30px',
        width: '100%',
        textAlign: align,
        cursor: 'pointer',
        position: 'relative',
        padding: '6px 8px'
      }}
    >
      {content}
    </div>
  );

  const handleDrop = async (event, target, targetIdFromRow = null) => {
    event.preventDefault();
    if (target === "right" && !targetIdFromRow) {
      return;
    }
    if (target === "right") {
      let raw =
        event.dataTransfer.getData("application/json") ||
        event.dataTransfer.getData("text/plain");
      if (!raw) return;

      let payload = null;
      try {
        payload = JSON.parse(raw);
      } catch (e) {
        return;
      }
      let ids = [];
      if (payload && Array.isArray(payload.ids)) {
        ids = payload.ids;
      } else if (payload && payload.id) {
        ids = [payload.id];
      } else if (Array.isArray(payload)) {
        ids = payload;
      }
      if (!ids || ids.length === 0) return;
      const itemsToAdd = requests.filter(r => ids.includes(r.id));
      if (itemsToAdd.length === 0) return;
      const delay = (ms) => new Promise(res => setTimeout(res, ms));
      setLoading(true);
      setLoadingDropTransfer(true);
      setLoadingRequests(true);
      setLoadingItems(true);
      try {
        for (let i = 0; i < itemsToAdd.length; i++) {
          const droppedItem = itemsToAdd[i];
          await apiCall(
            'put',
            '/api/v2/inventory-document-item/transfer-supplier/' +
              targetIdFromRow +
              '/receipt-item/' +
              droppedItem.id,
            {
              purchase_order: Number(id),
              purchase_order_request_item: droppedItem.id,
            }
          );
          if (i < itemsToAdd.length - 1) {
            await delay(10);
          }
        }
        window.App.toastShow('success', 'Sikeres mentés!');
        await loadLazyData();
        await loadLazyDataItems();
        setSelectedRequests([]);
      } catch (error) {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      } finally {
        setLoading(false);
        setLoadingDropTransfer(false);
        setDraggingItemIds([]);
        setDraggingItemLabel('');
        setDragOverTargetId(null);
      }
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    //console.log(handleDragOver)
  };

  // useEffect(() => {
  //   loadLazyData()
  // }, [lazyParams, window.App.state.rerenderPurchaserequestItems, window.App.state.rerenderPurchaseorderItems])

  useEffect(() => {
    if (id) {
      loadLazyDataItems()
    }
  }, [lazyParamsItems, window.App.state.rerenderPurchaserequestItems, window.App.state.rerenderPurchaseorderItems, window.App.state?.rerenderPurchaseorderInventorydocumentCopyDnd])

  useEffect(() => {
    if (window.App.urlVars().materialId) {
      setLoading(true)
      apiCall('post', '', {
        purchase_order: Number(id),
        purchase_order_request_item: window.App.urlVars().requestItemId,
        substitution_material: window.App.urlVars().materialId
      })
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          history.push('/procurement/' + entity + '/' + action + '/' + id)
          loadLazyDataItems()
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [window.App.urlVars().materialId])

  useEffect(() => {
    loadLazyData()
  }, [lazyParams, receiptId, window.App.state.rerenderPurchaserequestItems, window.App.state.rerenderPurchaseorderItems, window.App.state?.rerenderPurchaseorderInventorydocumentCopyDnd])

  // useEffect(() => {
  //   if (hasValidPoId) {
  //     setLoading(true);
  //     apiCall('get', '/api/v2/purchase-order/' + (window.App.urlVars().purchaseorderId ?? id))
  //       .then(response => {
  //         setFormData(response.data.data)
  //       })
  //       .catch(error => {
  //         window.App.toastShow('error', t('error'), error.toString(), '', error.response);
  //       })
  //   }
  // }, [window.App.state.rerenderPurchaserequestDnd])

  return (
    <div className={"purchaserequest-dnd widget"}>
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-6"}
             onDragOver={handleDragOver}
        >
          <Panel>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                  {t('deliveryNoteItems')}
                </h3>
              </div>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
              </div>
            </div>
            <BlockUI
              blocked={(formData.status === 'ORDERED' || formData.status === 'DELETED' || formData.status === 'CLOSED')}>
              <DataTable
                emptyMessage={t('noResults')}
                size={"small"}
                value={items} paginator first={lazyParamsItems.first} totalRecords={totalRecordsItems}
                scrollable scrollHeight="calc(100vh - 330px)"
                onPage={onPageItems}
                onSort={onSortItems} sortField={lazyParamsItems.sortField} sortOrder={lazyParamsItems.sortOrder}
                onFilter={onFilterItems} filters={lazyParamsItems.filters} lazy
                paginatorTemplate={pagerItems} rows={rowsItems}
                autoLayout={true}
                filterDisplay="none"
                responsiveLayout="scroll"
                stripedRows
                ref={dtItems}
                dataKey="id"
                loading={loadingDropTransfer || loadingItems}
                rowClassName={(rowData) => {
                  const isLinked = !!linkedInventoryDocumentItemIds[rowData?.id];
                  if (dragOverTargetId === rowData.id) {
                    return 'dnd-drop-row-active';
                  }
                  if (isLinked) {
                    return 'dnd-drop-row-linked';
                  }
                  return 'dnd-drop-row';
                }}
              >
                <Column field="material.name" header={t('columnName')} sortable filter body={(rowData) =>
                  renderDropCell(rowData?.material?.name, rowData, 'left', true)
                }/>
                
                <Column header={t('columnQuantity')} sortable filter className={"p-text-right"} body={(rowData) =>
                  renderDropCell(
                    `${Number(rowData?.quantity || 0)} ${rowData?.unit?.name || ''}`,
                    rowData,
                    'right',
                    false
                  )
                }/>
                
              </DataTable>
            </BlockUI>
          </Panel>
        </div>
        <div className={"p-col-12 p-lg-6"}
             onDragOver={handleDragOver}
             onDrop={(e) => handleDrop(e, "left")}
        >
          <Panel>
            {/*{loadingRequests &&*/}
            {/*  <ProgressBar mode="indeterminate"*/}
            {/*               style={{*/}
            {/*                 height: '5px',*/}
            {/*                 position: "absolute",*/}
            {/*                 top: '-12px',*/}
            {/*                 left: 0,*/}
            {/*                 borderRadius: 0,*/}
            {/*               }}></ProgressBar>*/}
            {/*}*/}
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                  {t('selectedInvoiceItems')}
                </h3>
              </div>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
              </div>
            </div>
            <BlockUI
              blocked={(formData.status === 'ORDERED' || formData.status === 'DELETED' || formData.status === 'CLOSED')}>
              <DataTable
                className="receipt-items-table"
                emptyMessage={t('noResults')}
                size={"small"}
                value={requests} 
                scrollable scrollHeight="calc(100vh - 330px)"
                loading={loadingDropTransfer || loadingRequests}
                paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                onFilter={onFilter} filters={lazyParams.filters} lazy
                paginatorTemplate={pager} rows={rows}
                autoLayout={true}
                filterDisplay="none"
                responsiveLayout="scroll"
                // stripedRows
                expandedRows={expandedRows}
                onRowToggle={(e) => setExpandedRows(e.data)}
                rowExpansionTemplate={rowExpansionTemplate}
                ref={dt}
                dataKey="id"
                selection={selectedRequests}
                onSelectionChange={e => setSelectedRequests(e.value)}
                rowClassName={(rowData) => {
                  const isDragging = Array.isArray(draggingItemIds) && draggingItemIds.includes(rowData.id);
                  const isCompleted = isRequestItemCompleted(rowData);
                  if (isDragging) {
                    return 'dnd-drag-source-row-active';
                  }
                  if (isCompleted) {
                    return 'dnd-drop-row-linked';
                  }
                  return 'dnd-drag-source-row';
                }}
              >
                <Column expander style={{ width: '3rem' }} />
                <Column
                  selectionMode="multiple"
                  headerStyle={{ width: '3rem' }}
                />
                
                <Column field="description" header={t('columnName')} sortable filter body={(rowData) => (
                    <div
                      draggable
                      onDragStart={(e) => handleDragStart(e, rowData)}
                      onDragEnd={handleDragEnd}
                      style={{cursor: 'move', fontWeight: 700}}
                    >
                      {rowData?.description}
                    </div>
                  )}
                />
                <Column header={t('columnQuantity')} className="p-text-right"
                  body={(rowData) => (
                    <div draggable onDragStart={(e) => handleDragStart(e, rowData)} style={{cursor: 'move'}} onDragEnd={handleDragEnd}>
                      {Number(rowData?.quantity)} {rowData?.unit?.name}
                    </div>
                  )}
              ></Column>
                
                <Column field="net_amount" className="p-text-right" header={t('columnNetTotal')} sortable filter body={(rowData) => (
                    <div draggable onDragStart={(e) => handleDragStart(e, rowData)} style={{cursor: 'move'}} onDragEnd={handleDragEnd}>
                      {rowData?.net_amount}
                    </div>
                  )}></Column>
                {/*<Column
                  header={t('columnPurchaseRequestNumber')}
                  sortable
                  filter
                  body={(rowData) => {
                    const value = rowData?.purchase_order_request?.purchase_order_request_number;
                    return (
                      <div
                        draggable
                        style={{ cursor: 'move' }}
                        onDragStart={(e) => handleDragStart(e, rowData)}
                      >
                        {value}
                      </div>
                    );
                  }}
                />
                <Column field="upc" header={t('upc')} sortable filter
                        body={(rowData) => {
                          return (
                            <div draggable
                                 style={{cursor: 'move'}}
                                 onDragStart={(e) => handleDragStart(e, rowData)}
                            >
                              {rowData?.material?.upc}
                            </div>
                          )
                        }}
                ></Column>
                <Column field="quantity" header={t('columnQuantity')} sortable filter className={"p-text-right"}
                        body={(rowData) => {
                          return (
                            <div draggable
                                 style={{cursor: 'move'}}
                                 onDragStart={(e) => handleDragStart(e, rowData)}
                            >
                              {Number(rowData?.quantity)} {rowData?.unit?.name}
                            </div>
                          )
                        }}
                ></Column>
                <Column field="substitution_type.name" header={t('columnSubstitutionReason')} sortable filter
                        body={(rowData) => {
                          return (
                            <div draggable
                                 style={{cursor: 'move'}}
                                 onDragStart={(e) => handleDragStart(e, rowData)}
                            >
                              {rowData?.substitution_type?.name}
                            </div>
                          )
                        }}
                ></Column> */}
              </DataTable>
            </BlockUI>
          </Panel>
        </div>
      </div>
    </div>
  )
}
export default withTranslation('common')(PurchaseorderInventorydocumentCopyDndComponent);
